import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/services/app.service';


@Injectable({
  providedIn: 'root'
})
export class BloquearFilialGuard {

  constructor(private appService: AppService, private router: Router){}


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.podeAcessar();
  }

  private podeAcessar(){
    if (this.appService.isFilial()) {
      this.router.navigate(['/cotacoes']);
      return false;
    }
    return true;
  }

}
